module.exports = {"rE":"5.5.0"}